import { alpha, Skeleton } from "@mui/material";
import SmallTextAndIcon from "./SmallTextAndIcon";
import BoltIcon from "@mui/icons-material/Bolt";
import { getTheme } from "../../../theme";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { getUsersWithHighPain } from "../../../api/getOverviewData";
import { t } from "i18next";

type UsersWithHighPainProps ={
  projectCodes: string[];
  height: number;
}

export type UsersWithHighPainRef = {
     getPainData : () => number[],
     isReady : () => boolean
}


const UsersWithHighPain = forwardRef<UsersWithHighPainRef,UsersWithHighPainProps>( function UsersWithHighPain({
  projectCodes,
  height,
},ref ) {
  const [isLoading, setIsLoading] = useState(true);
  const theme = getTheme();
  const [data, setData] = useState<number[]>([]);


  useImperativeHandle(ref, () => ({
      getPainData: () => data,
      isReady: () => isLoading
    }));

  useEffect(() => {
    setIsLoading(true);

    if (projectCodes.length === 0) return;

    let controller = new AbortController();
    let isMounted = true;
    const fetchUsersWithHighPain = async () => {
      try {
        const result = await getUsersWithHighPain(projectCodes, controller);
        if (isMounted) {
          let highMLICount = 0;
          let mildMLICount = 0;
          for (var overallActivResult of result)
          {
            if (overallActivResult.highCount === undefined || overallActivResult.mildCount === undefined)
            {
                // TODO: Create Warning Message
            } else {
              highMLICount += overallActivResult.highCount;
              mildMLICount += overallActivResult.mildCount;
            }
          }
          setData([highMLICount, mildMLICount]);
        }
      } catch (error: any) {
        if (error.name === "AbortError") {
          console.log("Fetch aborted");
        } else {
          console.error("Fetch error:", error);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchUsersWithHighPain();

    return () => {
      isMounted = false;
      controller.abort(); // Abort the previous request
    };
  }, [projectCodes]);

  return data.length > 0 && isLoading === false ? (
    <SmallTextAndIcon
      height={height}
      title={`${t('users-with-high-pain')}`}
      content={data[0]}
      titleSecondary={`${t('users-with-mild-pain')}`}
      contentSecondary={data[1]}
      icon={BoltIcon}
      backgroundColor={alpha(theme.palette.secondaryChart, 0.1)}
      iconColor={alpha(theme.palette.secondaryChart, 0.9)}
    />
  ) : (
    <Skeleton
      sx={{
        borderRadius: "5px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
      }}
      animation="pulse"
      variant="rectangular"
      width={"100%"}
      height={height}
    />
  );
})


export {UsersWithHighPain}